export const colors = {
  amaranthPurple: '#AB2C43',
  antiqueRuby: '#822031',
  whiteChocolate: '#ECE2DC',
  chamoisee: '#9C7E58',
}